import { Input } from "antd";
import classnames from "classnames";
import PropTypes from "prop-types";

import Label from "shared/components/Label";

const Password = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  required,
  ...rest
}) => {
  return (
    <div
      className={classnames("input__wrapper", { __error: touched && errors })}
    >
      <Label label={label} icon={icon} required={required} />
      <div className={`input__wrapper--field`}>
        <Input.Password
          className={classnames({
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
          })}
          placeholder={placeholder}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

Password.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Password.defaultProps = {
  label: "",
  placeholder: "",
};

export default Password;
